import {Link, Socials} from "../../components";
import styles from './Hero.module.scss';
import logo from '../../resources/logo.svg';
import zvuk from '../../resources/zvuk.svg';
import hero from '../../resources/hero.png';
import ear from '../../resources/ear.png';
import quest from '../../resources/quest.png';
import cn from "classnames";

export const Hero = () => {
    return (
        <div className={styles.hero}>
            <header className={styles.header}>
                <Link className={styles.logo} link={process.env.REACT_APP_2X2_URL}>
                    <img src={logo} alt="2x2"/>
                </Link>
                <Socials icons={true}/>
                <Link className={styles.lottery} link={process.env.REACT_APP_PARTNER_URL}>
                    <img src={zvuk} alt="Звук"/>
                </Link>
            </header>
            <div className={styles.text}>
                <div className={styles.title}>
                    <img src={hero} alt="Квестуха"/>
                </div>
                <img className={cn(styles.mobile, styles.quest)} src={quest} alt="КвестУха"/>
                <div className={styles.desc}>Проверь, готовы ли твои ушки к кайфушке!</div>
                <img className={cn(styles.mobile, styles.ear)} src={ear} alt="Ухи"/>
            </div>
        </div>
    )
}